import React, { useEffect, useState } from "react";
import { Eye, LucideBoxes, Plus, ScrollText } from "lucide-react";
import { DataGrid, GridColumn, LinkButton } from "rc-easyui";
import { useTranslation } from "react-i18next";
import { apiSend, getRoute } from "@services/axios";
import { Progress } from "antd";
import FormSearch from "./forms/FormSearch";
import { Button, Col, Pagination, Row, Spinner, Table } from "react-bootstrap";
import ManageHeader from "@components/ManageHeader";
import { FaCalendarAlt, FaChevronLeft, FaChevronRight, FaInfoCircle } from "react-icons/fa";
import { money } from "@global/actions";
import { Config } from "@pages/configs/config";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { setSectionName } from "@services/redux/slices/globalSlice";
import { useDispatch } from "@uiw/react-json-view";


const Home = (props) => {
  const { t } = useTranslation();
  const [productList, setProductList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedProductType, setSelectedProductType] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [selectInput, setSelectInput] = useState(null);
  const config = new Config(t);
  // Add these state variables
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20); // or your preferred page size
    const [maxVisiblePages, setMaxVisiblePages] = useState(5);
    const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) {
        setMaxVisiblePages(2); // mobile
      } else if (window.innerWidth < 768) {
        setMaxVisiblePages(3); // tablet
      } else {
        setMaxVisiblePages(5); // desktop
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getStatusClass = (status) => {
    const statusMap = {
      'confirmed': 'status-confirmed',
      'pending': 'status-pending',
      'cancelled': 'status-cancelled',
      'completed': 'status-completed',
      'refunded': 'status-cancelled',
      'unpaid': 'status-pending'
    };
    return statusMap[status?.toLowerCase()] || 'status-pending';
  };


  // const loadData = async (page) => {
  //   setLoading(1);
  //   const payload = {
  //     status: selectedStatus ? selectedStatus?.value : "",
  //     productType: selectedProductType?.value ? selectedProductType?.value : "",
  //     countryId: selectedCountryCode?.value ? selectedCountryCode?.value : "",
  //     cityId: selectedCity?.value ? selectedCity?.value : "",
  //     name: document.getElementById("searchText").value,
  //   };
  //   const response = await apiSend(
  //     getRoute("product_list") + "?page=" + page,
  //     "post",
  //     payload
  //   );

  //   if (response?.data?.result?.total >= 0) {
  //     setProductList(response?.data?.result.data);
  //     setTotal(response?.data?.result?.total);
  //   }
  //   setLoading(0);
  // };
  const totalPages = Math.ceil(total / pageSize);

  const loadData = async (page) => {
    setLoading(true);
    setCurrentPage(page);

    const payload = {
      status: selectedStatus ? selectedStatus?.value : "",
      productType: selectedProductType?.value ? selectedProductType?.value : "",
      countryId: selectedCountryCode?.value ? selectedCountryCode?.value : "",
      cityId: selectedCity?.value ? selectedCity?.value : "",
      name: document.getElementById("searchText").value,
    };

    const response = await apiSend(
      getRoute("product_list") + "?page=" + page,
      "post",
      payload
    );

    if (response?.data?.result) {
      setProductList(response.data.result.data || []);
      setTotal(response.data.result.total || 0);
    }
    setLoading(0);
  };


  useEffect(() => {
    const timerId = setTimeout(async () => {
      await loadData(1);
      
    }, 100);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const handlePageChange = (page) => {
    loadData(page);
  };


  return (

    <div className="table-container p-4 bg-white rounded-4 shadow">
      {/* <ManageHeader
        title={t("my_products")}
        content={t("overview_products")}
        icon={<LucideBoxes size={25} strokeWidth={1.5} />}
      /> */}
      <Row className="align-items-center">
         <Col xs="8" sm="6" className="my-2 ">
         <Button className="btn-custom-outline" onClick={() => navigate('/new-product')}>
          <Plus size={25} strokeWidth={1.2} /> {t("add_product")}
         </Button>
         
        </Col>
        <Col xs="4" sm="6" className="my-2">
      
        </Col>
       
      </Row>
      <FormSearch
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        selectedProductType={selectedProductType}
        setSelectedProductType={setSelectedProductType}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        selectedCountryCode={selectedCountryCode}
        setSelectedCountryCode={setSelectedCountryCode}
        selectInput={selectInput}
        setSelectInput={setSelectInput}
        loadData={loadData}
      />
      <div>
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" className="text-blue" />
          </div>
        ) : (
          <>
            <div className="table-responsive-custom">
              <Table className="table booking-table mb-0 align-middle">
                <thead>
                  <tr>
                    <th className="text-start">N°</th>
                    <th className="text-start">{t("name")}</th>
                    <th className="text-center d-none d-md-table-cell">{t("destination")}</th>
                    <th className="text-center d-none d-lg-table-cell">{t("date")}</th>
                    <th className="text-center d-none d-sm-table-cell">{t("status")}</th>
                    {/* <th className="text-end d-none d-xl-table-cell">{t("progress")}</th> */}
                    <th className="text-center">{t("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {productList.map((row, index) => (
                    <tr key={index} className="booking-row">
                      <td>
                        <div className="booking-number">
                          <span className="service-icon">
                            {config.serviceIcon(row.service)}
                          </span>
                          <span className="fw-semibold text-dark">{row.bookingNumber}</span>
                        </div>
                      </td>
                      <td className="fw-medium text-dark">{row.name}</td>
                      <td className="text-center d-none d-md-table-cell">
                        <span className="text-secondary d-inline-flex align-items-center gap-2">

                          {row.destination}
                        </span>
                      </td>
                      <td className="text-center d-none d-lg-table-cell">
                        <span className="text-secondary d-inline-flex align-items-center gap-2">
                          <FaCalendarAlt className="text-blue" size={14} />
                          {row.created_at}
                        </span>
                      </td>
                      <td className="text-center d-none d-sm-table-cell">
                        <span className={`status-badge ${getStatusClass(row.status)}`}>
                          {row.status}
                        </span>
                      </td>
                      {/* <td className="fs-6 fw-light d-none d-xl-table-cell">
                        <Progress
                          percent={row.percentage}
                          size="small"
                          strokeColor="#8077EC"
                        />
                      </td> */}
                      <td className="text-center">
                        <button

                          type="button"
                          className="view-btn"
                        ><a
                          target="_blank"
                          href={`/products/${row.id}/${row.countryName}/${row.service}/${row.name}`}
                        >
                            <Eye size={18} strokeWidth={1.5} /></a>
                        </button>



                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>



            {totalPages > 1 && (
              <Row className="justify-content-between align-items-center mt-4 px-2">
                <Col xs={12}
                  lg={5} xl={6} className="text-secondary d-inline-flex align-items-center gap-2">
                  <FaInfoCircle className="text-blue" size={14} />
                  {t("showing")} {productList.length} {t("of")} {total} {t("products")}
                </Col>
                <Col xs={12}
                  lg={7} xl={6} className="d-flex gap-2 justify-content-end mt-2">
                  <Pagination className="custom-pagination mb-0">
                    <Pagination.First
                      onClick={() => handlePageChange(1)}
                      disabled={currentPage === 1}
                      className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                    >
                      <FaChevronLeft size={12} />
                      <FaChevronLeft size={12} className="ms-1" style={{ marginLeft: '-4px' }} />
                    </Pagination.First>
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                    >
                      <FaChevronLeft size={12} />
                    </Pagination.Prev>

                    {Array.from(
                      { length: Math.min(maxVisiblePages, totalPages) },
                      (_, i) => {
                        let pageNum;

                        const half = Math.floor(maxVisiblePages / 2);

                        if (totalPages <= maxVisiblePages) {
                          // Total pages less than visible limit
                          pageNum = i + 1;
                        } else if (currentPage <= half + 1) {
                          // Near the beginning
                          pageNum = i + 1;
                        } else if (currentPage >= totalPages - half) {
                          // Near the end
                          pageNum = totalPages - maxVisiblePages + i + 1;
                        } else {
                          // Middle range
                          pageNum = currentPage - half + i;
                        }

                        return (
                          <Pagination.Item
                            key={pageNum}
                            active={pageNum === currentPage}
                            onClick={() => handlePageChange(pageNum)}
                            className="border-0 rounded-3"
                          >
                            {pageNum}
                          </Pagination.Item>
                        );
                      }
                    )}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                    >
                      <FaChevronRight size={12} />
                    </Pagination.Next>
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                      className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                    >
                      <FaChevronRight size={12} />
                      <FaChevronRight size={12} className="ms-1" style={{ marginLeft: '-4px' }} />
                    </Pagination.Last>
                  </Pagination>
                </Col>
              </Row>
            )}
          </>
        )}
      </div>

      <style jsx="true">{`
        .table-container {
          background: white;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
        }

        .booking-table {
          border-collapse: separate;
          border-spacing: 0;
          width: 100%;
          font-size: 0.95rem;
        }

        .booking-table thead th {
          position: sticky;
          top: 0;
          background: var(--primary-blue);
          border-bottom: 2px solid #e2e8f0;
          padding: 12px 10px !important;
       
          color: white;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          z-index: 10;
          white-space: nowrap;
        }

        .booking-table tbody tr {
          transition: all 0.2s ease;
          border-bottom: 1px solid #f1f5f9;
        }

        .booking-table tbody tr:hover {
          background-color: var(--secondary-blue) !important;
          cursor: pointer;
        }

        .booking-table td {
          padding: 16px !important;
          vertical-align: middle;
          color: #334155;
          border-bottom: 1px solid #f1f5f9;
          background: white;
          white-space: nowrap;
        }

        .booking-number {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          color: #0f172a;
        }

        .service-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background: var(--secondary-blue);
          border-radius: 10px;
          color: var(--primary-blue);
          font-size: 1rem;
          transition: all 0.2s ease;
        }

        .service-icon svg {
          width: 17px;
          height: 17px;
        }

        .booking-row:hover .service-icon {
          background: white;
          color: var(--primary-blue);
          transform: scale(1.05);
        }

        .status-badge {
          padding: 6px 16px;
          border-radius: 30px;
          font-size: 0.85rem;
          font-weight: 600;
          display: inline-block;
          text-transform: capitalize;
          letter-spacing: 0.3px;
          transition: all 0.2s ease;
        }

        .status-confirmed {
          background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
          color: #2563eb;
          border: 1px solid #bfdbfe;
        }

        .status-pending {
          background: linear-gradient(135deg, #fef3c7 0%, #fffbeb 100%);
          color: #d97706;
          border: 1px solid #fde68a;
        }

        .status-cancelled {
          background: linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%);
          color: #dc2626;
          border: 1px solid #fecaca;
        }

        .status-completed {
          background: linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%);
          color: #16a34a;
          border: 1px solid #bbf7d0;
        }

        .price {
          font-weight: 700;
          color: #0f172a;
          font-size: 1.05rem;
        }

        .currency {
          color: #64748b;
          font-size: 0.85rem;
          background: #f1f5f9 !important;
          border: none;
        }

        .view-btn {
          background: transparent;
          border: none;
          padding: 10px;
          cursor: pointer;
          border-radius: 10px;
          transition: all 0.2s ease;
          color: #64748b;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
        }

        .view-btn:hover {
          background: var(--secondary-blue);
          color: var(--primary-blue);
          transform: scale(1.1);
        }

        .table-responsive {
          border-radius: 12px;
          scrollbar-width: thin;
          scrollbar-color: var(--primary-blue) #f1f5f9;
        }

        .table-responsive::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .table-responsive::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 10px;
        }

        .table-responsive::-webkit-scrollbar-thumb {
          background: var(--primary-blue);
          border-radius: 10px;
          opacity: 0.5;
        }

        .table-responsive::-webkit-scrollbar-thumb:hover {
          background: var(--primary-blue);
        }

        .custom-pagination .page-item .page-link {
          border: none;
          margin: 0 4px;
          border-radius: 10px !important;
          color: var(--primary-blue);
          font-weight: 500;
          padding: 8px 14px;
          transition: all 0.2s ease;
          box-shadow: none;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 40px;
          height: 40px;
        }

        .custom-pagination .page-item.active .page-link {
          background: var(--primary-blue);
          color: white;
          border-color: var(--primary-blue);
        }

        .custom-pagination .page-item .page-link:hover {
          background: var(--secondary-blue);
          color: var(--primary-blue);
          transform: translateY(-2px);
        }

        .custom-pagination .page-item.disabled .page-link {
          background: transparent;
          color: #ccc;
        }

        .bg-blue {
          background: var(--primary-blue) !important;
          transition: all 0.2s ease;
        }

        .bg-blue:hover {
          opacity: 0.9;
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(149, 73, 248, 0.25) !important;
        }

        .text-blue {
          color: var(--primary-blue) !important;
        }

        @media (max-width: 768px) {
          .booking-table td,
          .booking-table th {
            padding: 12px !important;
            font-size: 0.85rem;
          }
          
          .service-icon {
            width: 32px;
            height: 32px;
          }
          
          .status-badge {
            padding: 4px 12px;
            font-size: 0.75rem;
          }
        }
.table-responsive-custom {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
        // @media (max-width: 576px) {
        //   .booking-table {
        //     min-width: 1000px;
        //   }
        // }
      `}</style>



    </div>

  );
};

export default Home;
